import { EVM_NETWORK_IDS } from 'constants/networks'
import useActiveWeb3 from 'hooks/blockchain/useActiveWeb3'

export default function useAutoRouterSupported(): boolean {
  const { networkId } = useActiveWeb3()
  return Boolean(networkId && EVM_NETWORK_IDS.includes(networkId))
}
